import { useCompanyAuth } from '@src/context/auth/useCompanyAuth';
import { useClickOutside } from '@src/hooks/useClickOutside';
import { useCompanyInAppNotificationPolling } from '@src/hooks/useCompanyInAppNotificationPolling';
import { BlackBell } from '@src/ui/elements/icon/bell/BlackBell';
import { CompanyInAppNotificationTooltip } from '@src/ui/elements/tooltip/InAppNotificationTooltip';
import { useRef, useState } from 'react';

const CompanyNotification = () => {
  const [isOpen, setIsOpen] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const companyAuth = useCompanyAuth();
  const { profile } = companyAuth;

  const { notifications, isExistNewNotification, resetNewNotification } =
    useCompanyInAppNotificationPolling(profile?.isLogin ?? false);

  const handleToggle = (e?: React.MouseEvent) => {
    e?.preventDefault();
    setIsOpen((prev) => !prev);
    resetNewNotification();
  };

  useClickOutside([tooltipRef], () => setIsOpen(false));

  return (
    <div
      ref={tooltipRef}
      className='relative'
    >
      <BlackBell
        handleToggle={handleToggle}
        notifications={notifications}
        isExistNewNotification={isExistNewNotification}
      />

      {profile && profile.isLogin && isOpen && (
        <div className='absolute right-5 top-[52px] z-50'>
          <CompanyInAppNotificationTooltip
            notifications={notifications}
            onCancel={handleToggle}
          />
        </div>
      )}
    </div>
  );
};

export default CompanyNotification;
